import { apiRequest } from '@/core';
import { type ServerUpdateAllPayload } from '@/slices/matches/types';

export const serverUpdateAllRequest = async (
  matchData: ServerUpdateAllPayload,
) =>
  apiRequest<void>({
    endpoint: 'api/matches',
    method: 'PATCH',
    body: matchData,
  });
